import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import LocationPage from "../pages/location/page";
import LocationsHubPage from "../pages/locations/page";
import SitemapPage from "../pages/sitemap/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/locations",
    element: <LocationsHubPage />,
  },
  {
    path: "/locations/:city",
    element: <LocationPage />,
  },
  {
    path: "/sitemap",
    element: <SitemapPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
